/* import __COLOCATED_TEMPLATE__ from './fin-ai-agent-card.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

export default class FinAiAgentCard extends Component {
  @service declare router: RouterService;
  @service declare intercomEventService: $TSFixMe;

  @action
  onManageFinAiAgentClick() {
    this.router.transitionTo('apps.app.automation.fin-ai-agent.deploy.chat');
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'manage_fin_ai_agent_button',
      place: 'settings_channels_whatsapp',
      section: 'fin_ai_agent_card',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Whatsapp::FinAiAgentCard': typeof FinAiAgentCard;
    'new-settings/channels/whatsapp/fin-ai-agent-card': typeof FinAiAgentCard;
  }
}
